/** API: 0 = Üniversite (Yaz Stajı / İş Yeri Eğitimi), 1 = Lise (Beceri Eğitimi / Lise Yaz)
 *  Eski (combined) tip — geriye dönük uyumluluk için tutuluyor.
 */
export type InternType = "universiteZorunlu" | "liseBeceri";

export type ApplicationSource = "kariyerKapisi" | "manuel";

export enum InternStatus {
  AKTIF = 0,
  TAMAMLANDI = 1,
}

// ─────────────────────────────────────────────────────────
// YENİ SPEC (17.04.2026 toplantı sonrası)
// BE şeması geldiğinde bu tipler üzerinden mapping güncellenir.
// ─────────────────────────────────────────────────────────

/** Staj türü: Üniversite / Lise */
export type InternTypeV2 = "UNIVERSITY" | "HIGH_SCHOOL";

/** Staj alt kategorisi:
 *  - UNIVERSITY + MANDATORY_SUMMER → Üniversite Zorunlu Yaz Stajı
 *  - UNIVERSITY + WORKPLACE_TRAINING → Üniversite İş Yeri Eğitimi
 *  - HIGH_SCHOOL + MANDATORY_SUMMER → Lise Zorunlu Yaz Stajı
 *  - HIGH_SCHOOL + SKILL_TRAINING   → Lise Beceri Eğitimi
 */
export type InternSubCategory =
  | "MANDATORY_SUMMER"
  | "WORKPLACE_TRAINING"
  | "SKILL_TRAINING";

/** Staj yeri: Merkez / Taşra */
export type InternLocation = "CENTER" | "PROVINCIAL";

/** Staj yaptığı birim türü: Başkanlık / İşletme Müdürlüğü */
export type InternDepartmentType = "PRESIDENCY" | "BUSINESS_UNIT";

/** Başvuru şekli: Kariyer Kapısı / Şahsen */
export type ApplicationSourceV2 = "CAREER_GATE" | "IN_PERSON";

export interface Intern {
  id: string;
  /** Personel detay sayfasına gitmek için kullanılır (staff-management/:userId) */
  userId?: string;
  tc: string;
  name: string;
  /** Eski combined tip — geriye dönük */
  internType: InternType;
  applicationSource: ApplicationSource;
  unitOrBusiness: string;
  educationProgress: number; // 0-100
  status: InternStatus;
  createdAt: string;

  // ── Yeni spec alanları (liste görünümünde kullanılır) ──
  /** Yeni spec: ayrık staj türü */
  internTypeV2?: InternTypeV2;
  /** Yeni spec: staj alt kategorisi */
  subCategory?: InternSubCategory;
  /** Yeni spec: Merkez / Taşra */
  location?: InternLocation;
  /** Yeni spec: Başkanlık / İşletme Müdürlüğü */
  departmentType?: InternDepartmentType;
  /** Başlangıç / bitiş tarihleri listede kolon olarak gösterilir */
  startDate?: string;
  endDate?: string;
  /** Akademik kolonlar liste ekranında */
  school?: string;
  schoolDepartment?: string;
  /** İsim / soyad ayrımı — liste kolonlarında ayrı gösterilir */
  firstName?: string;
  lastName?: string;
  /** Sertifika hazırsa indirme butonu aktiftir (BullMQ işi bittiğinde true olur) */
  hasCertificate?: boolean;
}

/** GET /api/admin/interns/:id – tam detay (phone, email, school, dates, vb.) */
export interface InternDetail extends Intern {
  phone?: string;
  email?: string;
  /** Yeni spec alanları — opsiyonel, BE destek ekledikçe dolacak */
  iban?: string;
  address?: string;
  school?: string;
  schoolDepartment?: string;
  grade?: string;
  /** Okul numarası — yeni spec */
  schoolNumber?: string;
  startDate?: string;
  endDate?: string;
  departmentID?: string;
  supervisorID?: string;
  supervisorName?: string;
  /** Yeni spec: staj sorumlusu iletişim bilgisi (ad dışında) */
  supervisorContact?: string;
  /** Yeni spec — Lise özel alanları */
  parentName?: string;
  parentContact?: string;
  coordinatorName?: string;
  coordinatorContact?: string;
}

export interface InternFilters {
  search?: string;
  /** Eski combined filter — geriye uyumluluk */
  internType?: InternType;
  applicationSource?: ApplicationSource;
  status?: InternStatus;
  // ── Yeni spec filtreleri ──
  internTypeV2?: InternTypeV2;
  subCategory?: InternSubCategory;
  location?: InternLocation;
  departmentType?: InternDepartmentType;
  departmentID?: string;
  startDateFrom?: string;
  startDateTo?: string;
  school?: string;
  schoolDepartment?: string;
}

/** Staj tür + alt kategori ikili bileşenlerden eski combined değer türet.
 *  BE eski alanı hâlâ dönüyorsa liste mapping için kullanılır.
 */
export function combineInternTypeLegacy(
  t?: InternTypeV2,
  sub?: InternSubCategory,
): InternType {
  if (t === "HIGH_SCHOOL") return "liseBeceri";
  // UNIVERSITY (MANDATORY_SUMMER / WORKPLACE_TRAINING) → universiteZorunlu
  if (t === "UNIVERSITY") return "universiteZorunlu";
  // Undefined veya legacy: en güvenli default
  return sub === "SKILL_TRAINING" ? "liseBeceri" : "universiteZorunlu";
}

/** Eski combined değerden yeni ayrık tipi türet — edit modunda kullanılır. */
export function splitInternTypeLegacy(legacy?: InternType): {
  internTypeV2?: InternTypeV2;
  subCategory?: InternSubCategory;
} {
  if (legacy === "liseBeceri") {
    return { internTypeV2: "HIGH_SCHOOL", subCategory: "SKILL_TRAINING" };
  }
  if (legacy === "universiteZorunlu") {
    return { internTypeV2: "UNIVERSITY", subCategory: "MANDATORY_SUMMER" };
  }
  return {};
}
